<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useColorMode } from '@vueuse/core'
import LottiePlayer from '@/components/LottiePlayerComponent.vue'
import { useCommonStore } from '@/stores/CommonStore'

const mode = useColorMode({ attribute: 'color-scheme' })
const { loading } = storeToRefs(useCommonStore())

const loadingIconBackupUrl = computed(
  () =>
    `/loading/${mode.value == 'dark' ? 'loadingIconDark.json' : 'loadingIcon.json'}`
)
</script>

<template>
  <div class="display-contents">
    <div v-if="loading" class="app-loading">
      <LottiePlayer
        :src="loadingIconBackupUrl"
        :backupsrc="loadingIconBackupUrl"
        autoplay
        loop
        width="300px"
        height="300px"
      ></LottiePlayer>
    </div>
    <router-view />
  </div>
</template>

<style lang="scss">
@use '@/assets/sass/main.scss';
</style>
<style>
@import '@/assets/css/main.css';

.app-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  background: var(--background);
}
</style>
